import type { BeneficiaryContactPayload } from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Actions/beneficiaryContactsFetched';

export type BeneficiaryContactCreatedAction = {
	type: 'BENEFICIARY_CONTACT_CREATED';
	payload: BeneficiaryContactPayload;
	beneficiaryId: number;
};

export default (
	payload: BeneficiaryContactPayload,
	beneficiaryId: number,
): BeneficiaryContactCreatedAction => ({
	type: 'BENEFICIARY_CONTACT_CREATED',
	payload,
	beneficiaryId,
});
